
import CompoundCategoryNewComponent from "../../../components/compound_categories/New.vue";

export default {
  components: {
    CompoundCategoryNewComponent
  }
};
